module.exports = __webpack_public_path__ + "img/cai.ddecd753.png";